import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import your components for each page
import Kyohon from "./Kyohon";
import Collections from "./Collections";
import Notation from "./Notation";
// import Notate from "./Notate";
import Glossary from "./Glossary";
import Login from "./components/Login";
import Status from "./StatusPage";
import Favourites from "./Favourites";
import LandingPage from "./LandingPage";
import Toast from "./components/Toast";
import { ToastProvider } from "./ToastContext";
import "./App.css";
import { useAuth } from "./AuthContext";
import Admin from "./Admin"; // Assuming you have an Admin component

const App = () => {
  const user = useAuth();
  // undefined = auth still loading; null = logged out; object = logged in
  if (user === undefined) return <div className="auth-loading" />;
  const isAdmin = user?.email === "iamozthorn@gmail.com";
  return (
    <ToastProvider>
      <Router basename="/">
        <Toast />
        <div>
          <main>
          {/* Uncomment this line to use TestDb for testing purposes */}
          <Routes>
            <Route path="/" element={user ? <Kyohon /> : <LandingPage />} />
            <Route path="/glossary" element={<Glossary />} />
            <Route path="/login" element={<Login />} />
            <Route path="/status" element={<Status />} />
            <Route path="/notation" element={<Notation />} />
            {isAdmin && <Route path="/admin" element={<Admin />} />}
            {/* <Route path="/notate" element={<Notate />} /> */}
            <Route path="/collections" element={<Collections />} />
            <Route path="/favourites" element={<Favourites />} />
          </Routes>
        </main>
      </div>
    </Router>
    </ToastProvider>
  );
};

export default App;
